import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import { Survey1bcnex3xrekf as Survey } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/survey.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import { get_name3rurt0joopy8d as get_name } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import {
  SurveyNewPage2cofqn1wxyvtq as SurveyNewPage,
  get_displayNamexov4bi48nyz9 as get_displayName,
} from './SurveyNewPage.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { SurveyDetailPage3czjqatyupm6x as SurveyDetailPage } from './SurveyDetailPage.mjs';
import { get_availabilityText38mli3yvvkbrx as get_availabilityText } from './surveyComponents.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  maxWidth22r11xnm7d4h4 as maxWidth,
  addButton16duilic9iyqp as addButton,
} from '../components/view-utilities.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { h12aidul0n4qlwh as h1 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_0,
  tableRecycler8sos3tuo7qum as tableRecycler,
} from '../components/table.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function SurveyListPage$surveys$lambda($this$remember) {
  var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_surveys_tdixlc_k$();
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(Survey()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$4);
  this_0.ascending_ijynum_k$(get_name(it));
  var tmp$ret$0 = this_0.build_1k0s4u_k$();
  return tmp.query_so6xq1_k$(new (Query())(VOID, tmp$ret$0, VOID, 2147483647));
}
function SurveyListPage$render$lambda($this$shownWhen) {
  return $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function SurveyListPage$render$lambda_0($this$addButton) {
  return 'New survey';
}
function SurveyListPage$render$lambda_1($this$addButton) {
  onClick($this$addButton, VOID, VOID, VOID, SurveyListPage$render$lambda$slambda($this$addButton));
  return Unit_instance;
}
function SurveyListPage$render$lambda$slambda($this_addButton) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    get_pageNavigator($this_addButton.get_context_h02k06_k$()).navigate_sm5lxf_k$(new (SurveyNewPage())());
    return Unit_instance;
  }), 0);
}
function SurveyListPage$render$lambda_2(it) {
  return new (SurveyDetailPage())(it._id_1);
}
function SurveyListPage$render$lambda_3($this$text) {
  return 'Name';
}
function SurveyListPage$render$lambda_4($this$text, it) {
  return it.name_1;
}
function SurveyListPage$render$lambda_5($this$text) {
  return 'Audience';
}
function SurveyListPage$render$lambda_6($this$text, it) {
  return get_displayName(it.audience_1);
}
function SurveyListPage$render$lambda_7($this$text) {
  return 'Available';
}
function SurveyListPage$render$lambda_8($this$text, it) {
  return get_availabilityText(it);
}
function SurveyListPage$render$lambda_9($this$text) {
  return 'Questions';
}
function SurveyListPage$render$lambda_10($this$text, it) {
  return it.questions_1.get_size_woubt6_k$().toString();
}
function SurveyListPage$render$lambda_11($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
var SurveyListPageClass;
function SurveyListPage() {
  if (SurveyListPageClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        tmp.surveys_1 = remember(VOID, VOID, VOID, VOID, SurveyListPage$surveys$lambda);
      }
      get_title_iz32un_k$() {
        return new (Constant())(_Constant___init__impl__v45mub('Surveys'));
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_centered(element_0);
        var tmp$ret$10 = weight(this_2, 1.0);
        h1(tmp$ret$10, 'Surveys');
        var tmp = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        var this_3 = shownWhen(tmp, VOID, VOID, SurveyListPage$render$lambda);
        var tmp_0 = themed(this_3, ImportantSemantic_getInstance());
        var tmp_1 = SurveyListPage$render$lambda_0;
        addButton(tmp_0, tmp_1, SurveyListPage$render$lambda_1);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp_2 = weight(element, 1.0);
        var tmp_3 = SurveyListPage$render$lambda_2;
        var tmp_4 = Companion_instance_0;
        var tmp_5 = SurveyListPage$render$lambda_3;
        var tmp_6 = tmp_4.text_y5ktm4_k$(tmp_5, 2.0, SurveyListPage$render$lambda_4);
        var tmp_7 = Companion_instance_0;
        var tmp_8 = SurveyListPage$render$lambda_5;
        var tmp_9 = tmp_7.text$default_gwb2zv_k$(tmp_8, VOID, SurveyListPage$render$lambda_6);
        var tmp_10 = Companion_instance_0;
        var tmp_11 = SurveyListPage$render$lambda_7;
        var tmp_12 = tmp_10.text$default_gwb2zv_k$(tmp_11, VOID, SurveyListPage$render$lambda_8);
        var tmp_13 = Companion_instance_0;
        var tmp_14 = SurveyListPage$render$lambda_9;
        tableRecycler(tmp_2, this.surveys_1, tmp_3, [tmp_6, tmp_9, tmp_12, tmp_13.text$default_gwb2zv_k$(tmp_14, VOID, SurveyListPage$render$lambda_10)]);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_4 = shownWhen(element, VOID, VOID, SurveyListPage$render$lambda_11);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (Space())(this_4.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_1);
        this_4.willAddChild_hz2iwc_k$(element_1);
        element_1.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_1);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'SurveyListPage', SurveyListPage, VOID, [Page()]);
    SurveyListPageClass = $;
  }
  return SurveyListPageClass;
}
//region block: exports
export {
  SurveyListPage as SurveyListPage1qf6jxjitzrxe,
};
//endregion

//# sourceMappingURL=SurveyListPage.mjs.map
